import { useState } from 'react';
import { apiClient } from 'config/api';
import { useCustomerId } from '@hooks';

export interface ReassignBalanceBody {
  amount: number;
  areaId: string;
}

/** Balance reassigment to area */
const useBalanceReassigmentToArea = (mutate: () => void) => {
  const [retrieveBalance, setRetrieveBalance] = useState({
    loading: false,
    showSuccessAlert: false,
  });

  const { customerId } = useCustomerId();
  /**
   * Retrieves the balance
   * @param body - Contains
   * @param body.amount - The amount of balance to reassign.
   * @param body.areaId - Area id.
   */
  async function postRetrieveBalance(body: ReassignBalanceBody) {
    setRetrieveBalance((current) => ({
      ...current,
      loading: true,
    }));
    try {
      await apiClient.post('/v3/client/area/reassignment', {
        ...body,
        customerId,
      });

      setRetrieveBalance((current) => ({ ...current, showSuccessAlert: true }));
    } finally {
      mutate();
      setRetrieveBalance((current) => ({ ...current, loading: false }));
    }
  }
  /**
   * Close success alert handler
   */
  const closeSuccessAlertHandler = () => {
    setRetrieveBalance((current) => ({ ...current, showSuccessAlert: false }));
  };
  return { retrieveBalance, postRetrieveBalance, closeSuccessAlertHandler };
};

export default useBalanceReassigmentToArea;
